export const projects = [
  {
    title: "Bridal Glam",
    description: "Flawless, radiant makeup with soft glam touches — designed for your dream day.",
    src: "https://www.doortodoorbeauty.com//GalleryImage/16.jpeg",
    link: "/book/bridal-glam",
    color: "#fce7f3",
    duration: "60 mins",
    price: "₹1499"
  },
  {
    title: "Party Ready",
    description: "Shimmery eyes, bold lips and that perfect glow — all in the comfort of your home.",
    src: "https://www.doortodoorbeauty.com//GalleryImage/12.jpeg",
    link: "/book/party-glam",
    color: "#fde2e4",
    duration: "45 mins",
    price: "₹1299"
  },
  {
    title: "Natural Look",
    description: "Subtle, breathable makeup — perfect for daily elegance or a quick glow-up.",
    src: "https://www.doortodoorbeauty.com//GalleryImage/10.jpeg",
    link: "/book/natural-look",
    color: "#fff7f9",
    duration: "30 mins",
    price: "₹999"
  }
];
